import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { todayToUnix } from 'utils';
import { memo, useCallback, useMemo } from 'react';
import { Box } from '@mui/material';
import { MaterialBoolControl, MaterialDateTimeInput } from 'shared/components/fields';
import { ControlWithoutLabel } from 'shared/components/fields/control/without-label';
import * as moment from 'moment/moment';
window.moment = moment;
export const Until = memo(function Until(props) {
    const { value, onChange, readonly } = props;
    const until_enabled = useMemo(() => value != null, [value]);
    const toggleUntil = useCallback((checked) => {
        if (readonly) {
            return;
        }
        if (!checked) {
            onChange(null);
        }
        else {
            onChange(todayToUnix());
        }
    }, [readonly]);
    const now = moment();
    const yesterday = now.subtract(1, 'day');
    const isValidDate = useMemo(() => {
        if (!value) {
            return null;
        }
        const _current = moment(value * 1e3);
        return _current.isAfter(yesterday) ? null : 'Нельзя указать день в прошлом';
    }, [yesterday, value]);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 1, children: [_jsx(MaterialBoolControl, { color: "secondary", label: "\u041E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u044B\u0439 \u0441\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0434\u043E", value: until_enabled, onChange: toggleUntil }), until_enabled && (_jsx(ControlWithoutLabel, { onChange: onChange, value: value, field: (input_props) => (_jsx(MaterialDateTimeInput, { ...input_props, minDateTime: now.toDate().getTime(), disabled: readonly })), validation_result: isValidDate, validation_warnings_result: null }))] }));
});
